// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Nk5t","location":"Header_location__2dLwX"};